export enum TechnicalCriteriaEvaluationTypeEnum {
  Laboratory_Testing = 'Laboratory_Testing',
  Technical_Evaluation = 'Technical_Evaluation'
}
